<script setup lang="ts">
import { ref } from 'vue';
import { RouterLink, RouterView } from 'vue-router';
import { api } from './api';

const showAdminMenu = ref(false);

async function logout() {
  await api.get('/api/auth/logout');
  window.location.reload();
}
</script>

<template>
  <nav>
    <RouterLink to="/articles">博主文章</RouterLink>
    <RouterLink to="/digest/daily">每日大事</RouterLink>
    <RouterLink to="/digest/weekly">每周大事</RouterLink>
    <div class="admin-dropdown" @mouseenter="showAdminMenu = true" @mouseleave="showAdminMenu = false">
      <span class="admin-dropdown-trigger">管理</span>
      <div v-show="showAdminMenu" class="admin-dropdown-menu">
        <RouterLink to="/digest">大事管理</RouterLink>
        <RouterLink to="/channels">博主管理</RouterLink>
        <RouterLink to="/videos">视频管理</RouterLink>
        <RouterLink to="/settings">模型管理</RouterLink>
      </div>
    </div>
    <a href="#" @click.prevent="logout" class="logout-link">退出登录</a>
  </nav>
  <main>
    <RouterView />
  </main>
</template>
